export const categories = [
  {
    slug: 'access-tutorial',
    name: '访问教程',
    description: '暗网91入口获取、Tor浏览器配置与注册使用全流程指南',
    icon: 'ri-global-line',
    color: 'primary',
    articleCount: 3,
  },
  {
    slug: 'security-guide',
    name: '安全指南',
    description: '暗网交易安全、诈骗识别与恶意软件防范完整攻略',
    icon: 'ri-shield-check-line',
    color: 'accent',
    articleCount: 3,
  },
  {
    slug: 'privacy-protection',
    name: '隐私保护',
    description: '匿名通信技术、数据加密方法与个人隐私防护最佳实践',
    icon: 'ri-lock-line',
    color: 'primary',
    articleCount: 2,
  },
  {
    slug: 'in-depth-review',
    name: '深度评测',
    description: '暗网平台真实评测报告与暗网市场对比分析',
    icon: 'ri-file-search-line',
    color: 'accent',
    articleCount: 2,
  },
  {
    slug: 'latest-news',
    name: '最新动态',
    description: '暗网安全威胁趋势报告与全球监管政策最新动态',
    icon: 'ri-newspaper-line',
    color: 'primary',
    articleCount: 2,
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});